"use client";

import React from "react";
import FormFieldWrapper from "./formFieldWrapper";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { useAppSelector } from "@/store/hooks";
import { MinimumPurchaseType, PageType } from "@/types/coupon/discount";
import { useDiscountUpdate } from "@/hooks/useDiscountUpdate";
import { StandardFormInput } from "@/components/common/StandardFormInput";

const MinimumPurchaseRequirements = ({
  currentPage,
}: {
  currentPage: PageType;
}) => {
  const handleUpdate = useDiscountUpdate();
  const {
    minimum_purchase_type,
    minimum_purchase_value_amount,
    minimum_purchase_value_quantity,
  } = useAppSelector((state) => state.discount[currentPage]);
  const minimumRequirementOptions = [
    { value: "nothing", label: "No minimum requirements" },
    { value: "amount", label: "Minimum purchase amount (₹)" },
    { value: "quantity", label: "Minimum quantity of items" },
  ];
  const handleSelectionChange = (value: MinimumPurchaseType) => {
    handleUpdate(currentPage, { minimum_purchase_type: value });
  };

  const handleInputChange = ({
    field,
    value,
  }: {
    field: "minimum_purchase_value_amount" | "minimum_purchase_value_quantity";
    value: string;
  }) => {
    handleUpdate(currentPage, { [field]: value });
  };

  return (
    <FormFieldWrapper title="Minimum Purchase Requirements">
      <RadioGroup
        defaultValue={minimumRequirementOptions[0].value}
        className="space-y-4"
        value={minimum_purchase_type}
        onValueChange={handleSelectionChange}
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="nothing" id="nothing" />
          <Label htmlFor="nothing">No minimum requirements</Label>
        </div>
        <div className="space-y-2">
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="amount" id="amount" />
            <Label htmlFor="amount">Minimum purchase amount (₹)</Label>
          </div>
          {minimum_purchase_type === "amount" && (
            <div className="ml-6">
              <StandardFormInput
                type="number"
                label=""
                value={minimum_purchase_value_amount}
                placeholder="0"
                onChange={(e) => {
                  handleInputChange({
                    field: "minimum_purchase_value_amount",
                    value: e.target.value,
                  });
                }}
              />
            </div>
          )}
        </div>
        <div className="space-y-2">
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="quantity" id="quantity" />
            <Label htmlFor="quantity">Minimum quantity of items</Label>
          </div>
          {minimum_purchase_type === "quantity" && (
            <div className="ml-6">
              <StandardFormInput
                type="number"
                label=""
                value={minimum_purchase_value_quantity}
                placeholder="0"
                onChange={(e) => {
                  handleInputChange({
                    field: "minimum_purchase_value_quantity",
                    value: e.target.value,
                  });
                }}
              />
            </div>
          )}
        </div>
      </RadioGroup>
    </FormFieldWrapper>
  );
};

export default MinimumPurchaseRequirements;
